
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default() {
        return []
      },
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gallery: null,
      options: {
        threshold: 10,
        resizeObserver: true,
        slidesPerView: this.images.length && this.images.length != 1 ? 1.25 : 1,
        centeredSlides: this.images.length && this.images.length != 1 ? true : false,
        spaceBetween: 10,
        loop: this.images.length && this.images.length != 1 ? true : false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 15,
            slidesPerView: this.images.length && this.images.length != 1 ? 1.25 : 1,
          },
        },
      },
    }
  },
  computed: {
    galleryImages() {
      return this.images.map((item) => {
        return { title: this.title, url: item.url }
      })
    },
    productImages() {
      const arr = [...this.images]
      arr.shift()
      return arr
    },
  },
}
